<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-7">
            <div class="header-content">Banners</div>
            <div class="sub-content mt-3">Create and manage announcement banners shown to service users.</div>
        </div>
        <div class="col-3 d-flex align-items-center justify-content-end">
            <button class="btn d-flex align-items-center justify-content-center primary-bg text-white" (click)="openCreateDialog()" style="width:160px;">
                <mat-icon style="margin-right:8px;">add</mat-icon>
                <span>Add Banner</span>
            </button>
        </div>
        <div class="col-1"></div>
    </div>
</div>

<div class="row ml-0 mt-4">
    <div class="col-1"></div>
    <div class="col-10">
        <table class="banner-table w-100" *ngIf="bannerList.length">
            <thead>
                <tr>
                    <th>Message</th>
                    <th>Start (IST)</th>
                    <th>End (IST)</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let banner of bannerList">
                    <td class="message-cell" [innerHTML]="banner.message"></td>
                    <td>{{ banner.start_datetime }}</td>
                    <td>{{ banner.end_datetime }}</td>
                    <td>
                        <span class="status-badge" [ngClass]="statusClass(banner.status)">{{ banner.status }}</span>
                    </td>
                    <td>
                        <button class="btn btn-sm action-btn mr-2" (click)="openEditDialog(banner)" title="Edit">
                            <mat-icon class="font-18">edit</mat-icon>
                        </button>
                        <button class="btn btn-sm action-btn-danger" (click)="confirmDelete(banner)" title="Delete">
                            <mat-icon class="font-18">delete</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="sub-content mt-5 text-center" *ngIf="!bannerList.length">
            No banners yet. Click "Add Banner" to create one.
        </div>
    </div>
    <div class="col-1"></div>
</div>

<!-- Create / Edit Dialog trigger (hidden) -->
<button class="d-none" id="bannerDialogTrigger" data-target="#banner-dialog" data-toggle="modal"></button>

<!-- Create / Edit Dialog -->
<div class="modal" id="banner-dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content sub-content" style="border-radius: 10px;">
            <div class="modal-header">
                <h5 class="modal-title">{{ isEditing ? 'Edit Banner' : 'Create Banner' }}</h5>
                <button type="button" class="close" data-dismiss="modal" id="bannerDialogClose">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="bannerForm">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold">Message</label>
                        <quill-editor
                            class="mt-2 d-block"
                            formControlName="message"
                            [modules]="quillModules"
                            placeholder="Enter banner message">
                        </quill-editor>
                        <small class="text-muted" [class.text-danger]="messageLength > messageMaxLength">{{ messageLength }} / {{ messageMaxLength }}</small>
                        <div class="text-danger font-12 mt-1" *ngIf="bannerForm.get('message')?.touched && bannerForm.get('message')?.errors?.['required']">
                            Message is required.
                        </div>
                        <div class="text-danger font-12 mt-1" *ngIf="bannerForm.get('message')?.touched && bannerForm.get('message')?.errors?.['maxlength']">
                            Message exceeds {{ messageMaxLength }} characters.
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-group">
                            <label class="font-weight-bold">Start Date &amp; Time (IST)</label>
                            <input
                                type="datetime-local"
                                class="form-control mt-2"
                                formControlName="start_datetime">
                            <div class="text-danger font-12 mt-1" *ngIf="bannerForm.get('start_datetime')?.touched && bannerForm.get('start_datetime')?.invalid">
                                Start date &amp; time is required.
                            </div>
                        </div>
                        <div class="col-6 form-group">
                            <label class="font-weight-bold">End Date &amp; Time (IST)</label>
                            <input
                                type="datetime-local"
                                class="form-control mt-2"
                                formControlName="end_datetime">
                            <div class="text-danger font-12 mt-1" *ngIf="bannerForm.get('end_datetime')?.touched && bannerForm.get('end_datetime')?.invalid">
                                End date &amp; time is required.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button class="btn primary-bg text-white" (click)="saveBanner()" [disabled]="bannerForm.invalid">
                    {{ isEditing ? 'Update' : 'Create' }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Confirmation trigger (hidden) -->
<button class="d-none" id="deleteDialogTrigger" data-target="#banner-delete-dialog" data-toggle="modal"></button>

<!-- Delete Confirmation Dialog -->
<div class="modal" id="banner-delete-dialog">
    <div class="modal-dialog">
        <div class="modal-content sub-content" style="border-radius: 10px;">
            <div class="modal-body text-center py-4">
                <span class="material-symbols-rounded primary-btn-txt" style="font-size: 60px;">delete</span>
                <h4 class="modal-title mt-2">Are you sure?</h4>
                <p class="mt-2">This banner will be permanently deleted.</p>
                <div class="d-flex align-items-center justify-content-center py-2">
                    <div class="cursor w-25 primary-btn-txt font-15 mr-4" data-dismiss="modal" id="deleteDialogClose">Cancel</div>
                    <button class="btn d-flex justify-content-center align-items-center ml-3 font-15 w-25 primary-bg text-white" data-dismiss="modal" (click)="deleteBanner()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>
